import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';

import {
  closeCompanyContactModal,
  openCompanyContactModal,
  reset,
  sendCompanyContactUsForm
} from '../../redux/modules/company';
import {
  hideMessageModal,
  openMessageModal
} from '../../redux/modules/messageModal';
import { hideModalShare, openModalShare } from '../../redux/modules/shareModal';

import ShareButtonsRow from '../../components/ShareButtonsRow/ShareButtonsRow';
import checkRtlLanguage from '../../utils/checkRtlLanguage';

// styles
import * as styles from './BrokerCommunityContainer.scss';
import {
  communityDescriptionAdvantages,
  communityDescriptionMain
} from './description';
import HeaderPhones from '../../components/Company/HeaderPhones/HeaderPhones';
import ConsultationForm
  from '../../components/Company/ConsultationForm/ConsultationForm';
import { AnalyticsEventService } from '../../services';
import makeSharingUrl from '../../utils/makeSharingUrl';
import { PRODUCTION_IMAGE_DOMAIN_BASE_URL } from '../../constants';

export const BROKER_COMPANY_NAME = 'רשת ברוקר - סטנדרט חדש בנדל״ן';
export const BROKER_COMPANY_NAME_SHORT = 'רשת ברוקר';
export const BROKER_COMPANY_LOGO = `${PRODUCTION_IMAGE_DOMAIN_BASE_URL}/images/partners/broker_logo.webp`;
export const BROKER_COMPANY_EMAIL = 'ben@broker-re.co.il';
export const BROKER_COMPANY_PHONE = '072-391-0001';

class BrokerCommunityContainer extends Component {
  state = {
    captcha: null
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.formSubmitted && nextProps.formSubmitted) {
      this.props.reset();
      this.openSuccessMessage();
    }
  }

  openSuccessMessage = () => this.props.openMessageModal({
    message: (
      <div className="successMessage">
        <span>{this.props.translate('companyPage', 'contactsForm', 'submitting_success')}</span>
      </div>
    ),
    messageModalClassName: 'company-message-modal'
  });

  formConsultationSubmitHandler = formValues => {
    const { captcha } = this.state;

    this.props.sendCompanyContactUsForm({
      ...formValues,
      captcha,
      receiver_name: BROKER_COMPANY_NAME_SHORT,
      to: BROKER_COMPANY_EMAIL,
      is_community_member: true
    });
  };

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  }

  renderConsultationForm = (companyName, className, field_id) => (
    <ConsultationForm
      fetchReCaptchaToken={this.fetchReCaptchaToken}
      locale={this.props.locale}
      field_id={field_id}
      companyName="רשת ברוקר"
      className={className}
      translate={this.props.translate}
      onSubmit={this.formConsultationSubmitHandler}
      isRtl={this.props.isRtl}
      formSubmitting={this.props.formSubmitting}
      formSubmitted={this.props.formSubmitted}
      formConsultationError={this.props.formError}
    />
  );

  renderShareButton = () => {
    const sharingData = {
      sharingUrl: makeSharingUrl('/professionals/broker', this.props.locale),
      sharingTitle: BROKER_COMPANY_NAME
    };

    return (
      <ShareButtonsRow
        sharingData={sharingData}
        isMobile={this.props.isMobile}
        isNative={this.props.isNative}
        locale={this.props.locale}
        copyLinkTitle={`${this.props.translate('copyLink')}`}
        shareTitle={`${this.props.translate('companyPage', 'shareTitle')}`}
        className="companySocialIcons"
        isHideShareTitle
      />
    );
  };

  renderDescription = () => (
    <div className={styles.description}>
      <div className={styles.descriptionTitle}>{BROKER_COMPANY_NAME}</div>
      <div>{communityDescriptionMain}</div>

      <br />
      <div className={styles.descriptionTitle}>למה ברוקר?</div>
      <div className={styles.listBlock}>
        {communityDescriptionAdvantages.map((item) => (
          <li>
            <span className="icon icon-check" />
            <strong>{item[0]}</strong>
            {item[1]}
          </li>
        ))}
      </div>
    </div>
  );

  renderDesktopContent = () => (
    <div className={cx(styles.topWrap, styles.brokerWrap)}>
      <span className={styles.bgCover} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logo}><img src={BROKER_COMPANY_LOGO} alt="BROKER_COMPANY_LOGO" /></div>
          <div>
            <h1 className={styles.title}>{BROKER_COMPANY_NAME}</h1>
            <HeaderPhones
              translate={this.props.translate('companyPage')}
              phoneNumber={BROKER_COMPANY_PHONE}
              locale={this.props.locale}
              isMobile={this.props.isMobile}
            />
            <br />
            {this.renderConsultationForm(BROKER_COMPANY_NAME, 'headerTopForm', 'broker_company_name_form')}

            {this.renderShareButton()}
            <br />
            <div className={styles.infoMessage}>משווקים נדל״ן ב-4 שפות</div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <div>
        {this.renderDesktopContent()}
        {this.renderDescription()}
      </div>
    );
  }
}

BrokerCommunityContainer.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isNative: PropTypes.bool,
  translate: PropTypes.func,
  formSubmitted: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  formError: PropTypes.object,
  isModalShareOpen: PropTypes.bool,
  sendCompanyContactUsForm: PropTypes.func,
  openMessageModal: PropTypes.func,
  location: PropTypes.object,
  reset: PropTypes.func,
  isRtl: PropTypes.bool
};

const mapStateToProps = (state) => ({
  locale: state.lang.locale,
  isRtl: checkRtlLanguage(state.lang.locale),
  isMobile: state.windowDimentions.isMobile,
  translate: getLang(state.lang, 'static'),
  formSubmitted: state.company.formSubmitted,
  formSubmitting: state.company.formSubmitting,
  formError: state.company.formError,
  isNative: state.native.isNative,
  isModalShareOpen: state.shareModal.isModalShareOpen
});

const mapDispatchToProps = {
  openCompanyContactModal,
  closeCompanyContactModal,
  sendCompanyContactUsForm,
  openMessageModal,
  hideMessageModal,
  reset,
  openModalShare,
  hideModalShare
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrokerCommunityContainer);
